




export default {
	name: 'app',
};
